<script>
import CouponForm from './CouponForm'
import CouponAssigned from './CouponAssigned'
import CouponTarget from './CouponTarget'
import cloneDeep from 'lodash/cloneDeep'

import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
export default {
  components: { CouponForm, CouponAssigned, CouponTarget },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    isAssigned: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    goods: {
      type: Array,
      required: true,
    },
    prepaids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: '0',
      couponData: cloneDeep(this.defaultValue),
      tabList: Object.freeze([
        {
          title: '基本資訊',
          component: () => import('./CouponForm'),
        },
        {
          title: '適用項目',
          component: () => import('./CouponAssigned'),
        },
        {
          title: '適用對象',
          component: () => import('./CouponTarget'),
        },
      ]),
      tryingToSave: false,
      tryingToSend: false,
      tryingToRemove: false,
      allMembers: [],
    }
  },
  computed: {
    availableMembers() {
      let filterMembers = []
      if (this.defaultValue.availableTags.length === 0 && this.defaultValue.availableMembers.length === 0) {
        filterMembers = this.allMembers
      } else {
        const availableTagIds = this.defaultValue.availableTags.map((item) => item.id)
        const availableMemberIds = this.defaultValue.availableMembers.map((item) => item.id)
        const blockMemberIds = this.defaultValue.blockMembers.map((item) => item.id)
        filterMembers = this.allMembers.filter((member) => {
          const tagids = member.tags.map((item) => item.id)
          const isAvailable = tagids.some((item) => {
            return availableTagIds.includes(item)
          })
          if (isAvailable && !blockMemberIds.includes(member.id)) {
            return true
          } else {
            if (availableMemberIds.includes(member.id)) {
              return true
            }
          }
        })
      }
      return filterMembers
    },
  },
  watch: {
    isAssigned() {
      this.activeTab = '2'
    },
  },
  created() {
    this.tryToSearch()
  },
  methods: {
    async tryToSearch() {
      this.allMembers = []
    },
    getCoupon() {
      this.$store.dispatch('coupon/fetchSingle', this.$route.params.couponId).then((coupon) => {
        this.$emit('update:defaultValue', coupon)
      })
    },
    async onClickSave() {
      await this.validate()
      this.tryingToSave = true
      try {
        const submitData = Object.assign({}, this.couponData, this.$refs.step2.filterSubmitData)
        if (this.couponData.storeIds.length === 0 && this.couponData.goodsStoreIds.length === 0) {
          this.$confirm('請至少選擇一個分店', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.activeTab = '1'
          this.tryingToSave = false
          return
        }
        if (this.couponData.serviceIds.length === 0 && this.couponData.goodsServiceIds.length === 0) {
          this.$confirm('請至少選擇一個服務項目', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.activeTab = '1'
          this.tryingToSave = false
          return
        }
        await this.$store.dispatch('coupon/store', submitData)
        messageStore('edit')
        // await this.$alert('儲存成功', '太棒了！', {
        //   confirmButtonText: '確認',
        //   type: 'success',
        //   center: true,
        // })
        this.tryingToSave = false
        this.getCoupon()
      } catch (error) {
        this.tryingToSave = false
      }
    },
    async tryToRemove() {
      try {
        await messageBoxDelete('該優惠券')
        try {
          this.tryingToRemove = true
          await this.$store.dispatch('coupon/remove', { ids: [this.defaultValue.id] })
          messageDelete()
          this.$router.push({ name: 'coupon' })
        } finally {
          this.tryingToRemove = false
        }
      } catch {}
    },
    changePage(value) {
      this.$emit('changePage', value)
    },
    async beforeTabSwitch(activeName, oldActiveName) {
      return this.validate()
    },
    async validate() {
      const currentTab = `step${this.activeTab}`
      if (this.$refs[currentTab].$refs.form) await this.$refs[currentTab].$refs.form.validate()
    },
  },
}
</script>
<template>
  <div :class="$style.page">
    <el-tabs v-model="activeTab" stretch type="border-card" class="isStyleBase" :before-leave="beforeTabSwitch">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"> </el-tab-pane>
    </el-tabs>

    <CouponTarget v-show="activeTab === '2'" ref="step2" :class="$style.pageContent" :default-value.sync="couponData" @store="getCoupon" @change="changePage"> </CouponTarget>
    <keep-alive>
      <component
        :is="tabList[activeTab].component"
        v-if="activeTab !== '2'"
        :ref="`step${activeTab}`"
        :class="$style.pageContent"
        :default-value.sync="couponData"
        :products="products"
        :prices="prices"
        :goods="goods"
        :prepaids="prepaids"
        @store="getCoupon"
      >
      </component>
    </keep-alive>
    <div :class="$style.footer">
      <el-button class="is-round" type="danger" :loading="tryingToRemove" :disabled="tryingToRemove" @click="tryToRemove">刪除</el-button>
      <el-button class="is-round" :loading="tryingToSave" @click="$router.push({ name: 'coupon' })">取消</el-button>
      <el-button class="is-round" type="primary" :loading="tryingToSave" @click="onClickSave">儲存變更</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
